// src/Privacy.js
import React from "react";

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto p-6 text-egypt-cream">
      <h1 className="text-3xl font-bold mb-4 text-egypt-gold">Privacy Notice</h1>
      <p className="mb-4">Last updated: October 12, 2025</p>

      <p className="mb-4">
        We value your privacy and aim to keep this website simple, transparent, and respectful of your data.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-egypt-gold">1. No personal tracking</h2>
      <p className="mb-4">
        This website does not use cookies, fingerprinting, or any advertising identifiers.
        We do not collect names, email addresses, IP addresses, or any personal information about you.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-egypt-gold">2. Anonymous analytics</h2>
      <p className="mb-4">
        We use{" "}
        <a
          href="https://plausible.io/"
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-egypt-gold"
        >
          Plausible Analytics
        </a>{" "}
        to understand overall website usage. Plausible is a privacy-friendly analytics tool that measures
        site traffic without cookies or tracking technologies. All data is aggregated and completely
        anonymous — for example, total page views, referrers, and popular pages.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-egypt-gold">3. Purpose of data collection</h2>
      <p className="mb-4">
        We collect anonymous statistics only to understand how people use the site and to improve content,
        design, and performance. The information is not used for profiling, advertising, or resale.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-egypt-gold">4. Data processor</h2>
      <p className="mb-4">
        Our analytics provider is Plausible Insights OÜ, a European company based in Estonia. You can read
        their full data policy here:{" "}
        <a
          href="https://plausible.io/data-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-egypt-gold"
        >
          https://plausible.io/data-policy
        </a>
        .
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-egypt-gold">5. Legal basis</h2>
      <p className="mb-4">
        Because the analytics we use do not involve personal data, we do not require cookie banners or user
        consent. The processing is based on our legitimate interest in improving the website.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-egypt-gold">6. Contact</h2>
      <p className="mb-4">
        For any privacy-related questions, please contact us at{" "}
        <a href="mailto:you@example.com" className="underline text-egypt-gold">
          contact@jellifala.com
        </a>
        .
      </p>

      <p className="mt-8 text-sm text-egypt-cream/80">
        © {new Date().getFullYear()} jelli Fala. All rights reserved.
      </p>
    </div>
  );
}
